/**
 * Device detection utilities
 */

// Detect if running on a mobile device
export const isMobileDevice = () => {
  const userAgent = typeof window.navigator === 'undefined' ? '' : navigator.userAgent;
  const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  return mobileRegex.test(userAgent);
};

// Detect if the device has low memory (useful for further optimizations)
export const isLowMemoryDevice = () => {
  if (typeof navigator === 'undefined' || !navigator.deviceMemory) {
    return true; // Assume low memory if deviceMemory API not available
  }
  return navigator.deviceMemory < 4; // Less than 4GB RAM is considered low memory
};

// Custom hook for device detection
export const useDeviceDetection = () => {
  const isMobile = isMobileDevice();
  const isLowMemory = isLowMemoryDevice();
  
  return { isMobile, isLowMemory };
};

// Optimize background styles based on device
export const getOptimizedBackgroundStyles = (styles, isMobile = false) => {
  // If not mobile, return original styles
  if (!isMobile) return styles;
  
  // Clone the styles object
  const optimizedStyles = {...styles};
  
  // Remove or modify problematic styles
  if (optimizedStyles.backgroundAttachment === 'fixed') {
    optimizedStyles.backgroundAttachment = 'scroll';
  }
  
  // Use lower quality images if available
  if (optimizedStyles.backgroundImage && optimizedStyles.backgroundImage.includes('high-res')) {
    optimizedStyles.backgroundImage = optimizedStyles.backgroundImage.replace('high-res', 'low-res');
  }
  
  return optimizedStyles;
};
